import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestFormsApi from '../generated/api/RequestForms';

export default (service: Servicelayer) => ({
  ...RequestFormsApi(service),

  // Add custom calls here

});
